enum PreventiveCareNoticeLetterTypeEnum {
    None,
    FirstLetter,
    SecondLetter,
    PhoneCall
}

export { PreventiveCareNoticeLetterTypeEnum };
